export default __webpack_public_path__ + "static/media/se.f670a286.svg";